import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-navbar-link',
  templateUrl: './navbar-link.component.html',
})
export class NavbarLinkComponent {
    @Input() label!: string;
    @Input() icon!: string;
    @Input() route!: string;
    @Input() hasNotification: Boolean | null = false;
}
